<template lang="pug">
.app-dialog(:class="{ opened: show, loading: loading }")
  .modal.fade(:class="{ in: show }")
    .modal-backdrop.loader.fade(
      v-show="isDismissable"
      :class="{ in: show }"
    )
    .modal-dialog(
      v-loading="loading"
      :class="[dialogSize, position]"
      v-bind="$attrs"
    )
      .modal-content
        .modal-header(
          v-if="title"
          data-testid="app-dialog-header"
        )
          button.close(
            v-show="isDismissable"
            type="button"
            data-dismiss="modal"
            aria-hidden="true"
            data-testid="app-dialog-close-button"
            @click="close"
          )
            i.hi.hi-close.hi-12
          slot(name="corner")
          .d-flex
            slot(name="icon")
            h4.modal-title {{ title }}
              slot(name="titleLabel")
          .modal-subtitle(v-if="subtitle") {{ subtitle }}
          slot(name="header")
        .modal-body
          slot
        .modal-footer(v-if="hasFooter")
          slot(name="footer")
</template>

<script>
import { DIALOG_OPEN_WIN_EVENT } from '~/app_constants';
const MODAL_OPEN_BODY_CLASS = 'modal-open';

export default {
  inheritAttrs: false,
  props: {
    title: {
      type: String,
    },
    subtitle: {
      type: String,
      default: null,
    },
    show: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    isDismissable: {
      type: Boolean,
      default: true,
    },
    appendToBody: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
    },
    position: {
      type: String,
      default: 'top',
      validator: (value) => ['top', 'centered'].includes(value),
    },
  },
  computed: {
    hasFooter() {
      return this.$slots.footer;
    },
    dialogSize() {
      switch (this.size) {
        case 'small':
          return 'modal-sm';
        case 'smedium':
          return 'modal-smd';
        case 'medium':
          return 'modal-md';
        case 'large':
          return 'modal-lg';
        case 'x-large':
          return 'modal-lg modal-xl';
        case 'xx-large':
          return 'modal-lg modal-xxl';
        default:
          return '';
      }
    },
  },
  watch: {
    show(val) {
      if (val && this.appendToBody) {
        this.addBodyClass();
      } else {
        this.removeBodyClass();
      }

      this.dispatchWindowOpen();
    },
  },
  mounted() {
    if (this.appendToBody) {
      window.document.body.appendChild(this.$el);
    }

    if (this.appendToBody && this.show) {
      this.addBodyClass();
    }

    this.dispatchWindowOpen();

    document.addEventListener('keydown', this.handleEscapeKey);
  },
  beforeDestroy() {
    if (this.appendToBody) {
      if (this.show) {
        this.removeBodyClass();
      }

      if (this.$el.parentNode) {
        this.$el.parentNode.removeChild(this.$el);
      }
    }

    document.removeEventListener('keydown', this.handleEscapeKey);
  },
  methods: {
    dispatchWindowOpen() {
      if (this.show) {
        window.dispatchEvent(new CustomEvent(DIALOG_OPEN_WIN_EVENT));
      }
    },
    close() {
      this.$emit('close');
    },
    handleEscapeKey(e) {
      if (this.show === true && this.isDismissable === true && e.keyCode === 27) {
        this.close();
      }
    },
    addBodyClass() {
      window.document.body.classList.add(MODAL_OPEN_BODY_CLASS);
    },
    removeBodyClass() {
      window.document.body.classList.remove(MODAL_OPEN_BODY_CLASS);
    },
  },
};
</script>
